define('crud-service',[], function() {

  var app = angular.module('crud.service', [ ]);

  app.factory('crud', ['$q', '$http', 
    function($q, $http) {

      //var blockContentUI = blockUI.instances.get('page-content');

      return {

        setScope: function (objs) {
          if (_.isArray(objs)) {
            return objs[0];
          } else {
            return objs;
          }
        },

        setModuleName: function ($scope) {

          if (!$scope.$module) {
            $scope.$module = {};
          }

          if (!$scope.$module.name) {
            $scope.$module.name = 'Oops! Don\'t forget to set the breadcrumb';
          }

          if (!$scope.$module.pluralName) {
            $scope.$module.pluralName = $scope.$module.name + 's';
          }

        },

        indexScope: function(objs, $UI) {

         // utils.extendScope(objs);

          var $scope = this.setScope(objs);

          $scope.searchParams = {};

          $scope.search = function() {
            $scope.currentPage = 1;
           
          }

          $scope.setPage = function(page) {
            $scope.currentPage = page;
           
          }

          // Watch location.search (query string) for changes
          // and update list when it changes
          
          $scope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {

            if (newUrl === oldUrl) {
              return;
            }

            var newURI = new URI(newUrl);
            var oldURI = new URI(oldUrl);

            if (newURI.host() === oldURI.host() && newURI.path() === oldURI.path()) {
                $scope.list();
            }

          });

          if ($UI) {
            this.handleUI($scope, $UI.index);
          }


          // ==================
          // Hanlde breadcrumbs
          // ==================

          this.setModuleName($scope);

          $scope.title = $i18n.__($scope.$module.pluralName);

          new $breadcrumbs()
            .addCrumb($scope.title, $scope.$module.name + 'Index', true);

          $metadata.setTitle($scope.title);


          // ===========================
          // Handle table list chekboxes
          // ===========================

          $scope.selectAll = false;

          $scope.toggleSelection = function (item) {

            if (item) {
              item.selected = !item.selected;
            } else {
              $scope.selectAll = !$scope.selectAll;
              $scope.items.map(function(item){
                item.selected = $scope.selectAll;
              });
            }

            var checks = $scope.items;
            var checked = _.filter($scope.items, { selected: true });
            if (checks.length === checked.length) {
              $scope.selectAll = true;
            } else {
              $scope.selectAll = false;
            }

          };

        },

        'delete': function ($scope, promise) {
          return function (item) {
           // blockContentUI.start();
            promise(item).then(function(data) {
           //   blockContentUI.reset();
              if (data.data && data.data.redirect) {
                $scope.list();
              }
            });
          }
        },

        bulkDelete: function ($scope, promise) {
          return function () {
            var selected = _.filter($scope.items, { selected: true });
           // blockContentUI.start();
            promise(selected).then(function(data) {
            //  blockContentUI.reset();
              if (data && data.data && data.data.redirect) {
                $scope.list();
              }
            });
          }
        },

        addScope: function(objs, $UI) {

          //utils.extendScope(objs);

          var $scope = this.setScope(objs);

          //notify.clearNotifications();

          $scope.action = {
            title: $i18n.__('add')
          }

          $scope.btnSave = $i18n.__('save');

          if ($UI) {
            this.handleUI($scope, $UI.form);
          }

          this.setModuleName($scope);

          $scope.title = $i18n.__('add') + ' ' + $i18n.__($scope.$module.name).toLowerCase();

          new $breadcrumbs()
            .addCrumb($i18n.__($scope.$module.pluralName), $scope.$module.name + 'Index')
            .addCrumb($scope.title, $scope.$module.name + 'Add', true);

          $metadata.setTitle($scope.title);

        },

        editScope: function(objs, $UI) {

          //utils.extendScope(objs);

          var $scope = this.setScope(objs);

          //notify.clearNotifications();

          $scope.action = {
            title: $i18n.__('edit')
          }

          $scope.btnSave = $i18n.__('saveChanges');

          if ($UI) {
            this.handleUI($scope, $UI.form);
          }

          this.setModuleName($scope);

          $scope.title = $i18n.__('edit') + ' ' + $i18n.__($scope.$module.name).toLowerCase();

          new $breadcrumbs()
            .addCrumb($i18n.__($scope.$module.pluralName), $scope.$module.name + 'Index')
            .addCrumb($scope.title, $scope.$module.name + 'Edit', true);

          $metadata.setTitle($scope.title);

        },

        list: function($scope, fn) {
          return function(data) {

            if (!data) {
           //   data = appRoute.compactSearchParams.call($scope);
            }

            // var data = appRoute.compactSearchParams(data, {
            //   serialize: true
            // });

            fn(data);

          }
        },

        listSite : function($scope, Provider){
            $scope.initPagination = function() {
            $scope.itemsPerPage = 5;
            $scope.totalItems = 0;
            $scope.currentPage = 1;
            $scope.pagination = [];
            $scope.$watch('totalItems', function (totalItems) {
              var page = parseInt(totalItems / $scope.itemsPerPage);
              if((totalItems % $scope.itemsPerPage) > 0){
                page++;
              }
              var arr = [];
              for(var i = 1; i<= page; i++){
                arr.push({page:i});
              }
              $scope.pagination = arr;
            });
          }
          $scope.initPagination();
          $scope.getList = function(){
            var data = {
              pagination:{
                itemsPerPage: $scope.itemsPerPage,
                offset: (($scope.currentPage - 1) * $scope.itemsPerPage)
              }
            };
            Provider.getList(data).then(function(data) {
              $scope.itens =  data.items;
              $scope.totalItems = data.totalItems;
            });
          }
          $scope.getList();

          $scope.setPage = function(page){
            $scope.currentPage = page;
            $scope.getList();
          }

          $scope.delete = function(id){
            if(window.confirm('Você tem certeza que deseja excluir o registro?')){
              Provider.delete({id:id}).then(function(result){
                if(result.success){
                  $scope.getList();
                }
              })
            }
          }
        },
        resourceHandler: function(handler) {

          return function(data, options) {

            var config = _.merge({
              blockUI: true,
              showNotifications: true,
              clearNotifications: true
            }, options);

            if (config.clearNotifications) {
            //  notify.clearNotifications();
            }

            // if (config.blockUI) {
            //   blockContentUI.start();
            // }

            return $q(function(resolve, reject) {
              var httpPromise = handler(data);
              httpPromise.success(function(response) {
                var data = (response.data) ? response.data : response;
             //   blockContentUI.reset();
                if (config.showNotifications && data && data.notifications && !_.isEmpty(data.notifications)) {
              //    notify.addNotification(data.notifications);
                }
                if (data && data.redirect) {
                //  appRoute.redirect(data.redirect);
                }
                resolve(data);
              }).error(function(error) {
           //     blockContentUI.reset();
                if (config.showNotifications && error && error.notifications && !_.isEmpty(error.notifications)) {
              //    notify.addNotification('danger', $i18n.__('couldNotUpdateMenu'));
                }
                if (error && error.redirect) {
                 // appRoute.redirect(error.redirect);
                }
                reject(error);
              });
            });
          };

        }

      }
    }
  ]);

});

